import { SectionIds } from '@/components/Patient/ScheduledConsult/types';
import type { GuidedDoctorConsultsState } from './types';

export const DEFAULT_STATE: GuidedDoctorConsultsState = {
  guidedDoctorConsult: {
    fields: {
      notes: '',
      followUpWeekPeriod: null,
      complimentary: false,
    },
    isDirty: false,
    openSections: [SectionIds.PATIENT_CHECK],
  },
};
